// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
export type StatsTopItemFieldsFragment = { __typename?: 'RestaurantStats', topItems: Array<{ __typename?: 'ItemStats', amount: number, discount: number, itemGroupName?: string | null, name: string, quantity: number }> };

export const StatsTopItemFieldsFragmentDoc = gql`
    fragment statsTopItemFields on RestaurantStats {
  topItems {
    amount
    discount
    itemGroupName
    name
    quantity
  }
}
    `;